exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ap_information_base_text, .ap_confirmation_information, .ap_confirmation_text {\n  font-family: Manrope;\n  font-size: 20px;\n  font-weight: 200;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.ap_confirmation_text {\n  color: #4F9C20;\n}\n\n.ap_confirmation_information {\n  color: #6F6F6F;\n}\n\n.ap_info_container {\n  padding: 20px 0 0 0 !important;\n  margin-bottom: 70px;\n}", ""]);

// exports
